import React, { useEffect, useState } from "react";
import { useIframeUrlMutation } from "../../app/services/DashBoard/adminDashBoardApi";
import { formatISO } from "date-fns";

const MetaBaseDashBoardFour = () => {
  const [iframeUrls, setIframeUrls] = useState({ 44: "", 45: "", 46: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [iframeUrlApi] = useIframeUrlMutation();
  const getMonthDateRange = (date = new Date()) => {
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return { firstDay, lastDay };
  };

  useEffect(() => {
    const { firstDay, lastDay } = getMonthDateRange();
    setStartDate(firstDay);
    setEndDate(lastDay);
  }, []);

  const fetchIframeUrls = async (withFilter = false) => {
    setLoading(true);
    setError("");
    const ids = [44, 45, 46];
    const newUrls = {};
    try {
      for (const id of ids) {
        const requestPayload = {
          questionId: id,
          params: {
            StartDate:
              (withFilter || startDate) && startDate
                ? `${formatISO(startDate, { representation: "date" })} 00:00:00`
                : null,
            EndDate:
              (withFilter || endDate) && endDate
                ? `${formatISO(endDate, { representation: "date" })} 23:59:59`
                : null,
          },
          expMinutes: 10,
          bordered: true,
          titled: true,
        };
        const response = await iframeUrlApi(requestPayload).unwrap();
        newUrls[id] = response.iframeUrl;
      }
      setIframeUrls(newUrls);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch dashboard data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (startDate && endDate) {
      fetchIframeUrls(true);
    }
  }, [startDate, endDate]);

  const resetForm = () => {
    const { firstDay, lastDay } = getMonthDateRange();
    setStartDate(firstDay);
    setEndDate(lastDay);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const { firstDay, lastDay } = getMonthDateRange(now);
      if (
        startDate &&
        (startDate.getMonth() !== now.getMonth() ||
          startDate.getFullYear() !== now.getFullYear())
      ) {
        setStartDate(firstDay);
        setEndDate(lastDay);
      }
    }, 60000);
    return () => clearInterval(interval);
  }, [startDate]);

  return (
    <div style={{ position: "relative", padding: "20px" }}>
      <button
        onClick={resetForm}
        disabled={loading}
        style={{
          cursor: loading ? "not-allowed" : "pointer",
        }}
        class="btn success-btn reload-btn"
      >
        {loading ? "Loading..." : "Reload Current Month"}
      </button>
      <div className="iframe-card">
        <div>
          <label style={{ display: "block", marginBottom: "4px" }}>
            Start Date
          </label>
          <input
            type="date"
            value={
              startDate ? formatISO(startDate, { representation: "date" }) : ""
            }
            onChange={(e) =>
              setStartDate(e.target.value ? new Date(e.target.value) : null)
            }
            style={{
              padding: "6px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
          />
        </div>
        <div>
          <label style={{ display: "block", marginBottom: "4px" }}>
            End Date
          </label>
          <input
            type="date"
            value={
              endDate ? formatISO(endDate, { representation: "date" }) : ""
            }
            onChange={(e) =>
              setEndDate(e.target.value ? new Date(e.target.value) : null)
            }
            style={{
              padding: "6px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            }}
          />
        </div>
      </div>
      {loading && <p>Loading reports...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
      <div
        style={{
          // display: "flex",
          gap: "20px",
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        {[44, 45, 46].map((id) => (
          <div
            key={id}
            style={{
              // flex: "1 1 calc(33% - 20px)",
              minWidth: "350px",
              border: "1px solid #ddd",
              borderRadius: "10px",
              padding: "10px",
              backgroundColor: "#fafafa",
              marginBottom: "20px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            }}
          >
            {iframeUrls[id] ? (
              <iframe
                src={iframeUrls[id]}
                width="100%"
                height="350"
                frameBorder="0"
                style={{ borderRadius: "8px" }}
                title={`Metabase Report ${id}`}
              />
            ) : (
              <p style={{ textAlign: "center" }}>No data loaded yet</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MetaBaseDashBoardFour;
